import {Injectable} from "@angular/core";
import {CanDeactivate} from "@angular/router";
import {CommonMessagesService} from "../../services/common-messages.service";
import {ComponentCanDeactivate} from "./component-can-deactivate";

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  constructor(private commonMessagesService: CommonMessagesService) {
  }

  canDeactivate(component: ComponentCanDeactivate): Promise<boolean> | boolean {
    if (!component.canDeactivate()) {
      return new Promise(resolve => {
        this.commonMessagesService.showCancelRequestConfirmation(
          () => resolve(true),
          () => resolve(false)
        );
      })
    } else {
      return true;
    }
  }

}
